export type SettingsKey =
  | 'ENV_CCB_PAYMENT_INFORMATION_WAIT_TIME_IN_SECONDS'
  | 'EMAIL_VALIDATION_CODE_RESEND_WAIT_SECONDS'
  | 'PROPOSAL_RETRY_PULLING_INTERVAL';

export type ConfigSetting = {
  key: SettingsKey;
  value: string;
};

export type ResponseSettings = {
  all: ConfigSetting[];
  count: number;
  page: number;
  limit: number;
};

export const SETTINGS_KEYS = [
  'ENV_CCB_PAYMENT_INFORMATION_WAIT_TIME_IN_SECONDS',
  'EMAIL_VALIDATION_CODE_RESEND_WAIT_SECONDS',
  'PROPOSAL_RETRY_PULLING_INTERVAL',
] as SettingsKey[];
